var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'descripcio';
var defaultSortDirection = 'asc';
var BancCarreguesC60FilterService = /** @class */ (function (_super) {
    __extends(BancCarreguesC60FilterService, _super);
    function BancCarreguesC60FilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BancCarreguesC60FilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('id', (filter.id ? filter.id.toString() : ''))
            .append('codiCarrega', filter.codiCarrega)
            .append('descripcioCarrega', filter.descripcioCarrega)
            .append('nomFitxer', filter.nomFitxer)
            .append('directoriFitxer', filter.directoriFitxer)
            .append('situacio', filter.situacio)
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return BancCarreguesC60FilterService;
}(CustomFilterService));
export { BancCarreguesC60FilterService };
